var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6C10 4.4087 10.6321 2.88258 11.7574 1.75736C12.8826 0.632141 14.4087 0 16 0C17.5913 0 19.1174 0.632141 20.2426 1.75736C21.3679 2.88258 22 4.4087 22 6V16C22 17.5913 21.3679 19.1174 20.2426 20.2426C19.1174 21.3679 17.5913 22 16 22C14.4087 22 12.8826 21.3679 11.7574 20.2426C10.6321 19.1174 10 17.5913 10 16V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13C7.26522 13 7.51957 13.1054 7.70711 13.2929C7.89464 13.4804 8 13.7348 8 14V16C8 18.1217 8.84285 20.1566 10.3431 21.6569C11.8434 23.1571 13.8783 24 16 24C18.1217 24 20.1566 23.1571 21.6569 21.6569C23.1571 20.1566 24 18.1217 24 16V14C24 13.7348 24.1054 13.4804 24.2929 13.2929C24.4804 13.1054 24.7348 13 25 13C25.2652 13 25.5196 13.1054 25.7071 13.2929C25.8946 13.4804 26 13.7348 26 14V16C26 18.4791 25.0792 20.8698 23.4162 22.7083C21.7533 24.5468 19.4666 25.7021 17 25.95V30H23C23.2652 30 23.5196 30.1054 23.7071 30.2929C23.8946 30.4804 24 30.7348 24 31C24 31.2652 23.8946 31.5196 23.7071 31.7071C23.5196 31.8946 23.2652 32 23 32H9C8.73478 32 8.48043 31.8946 8.29289 31.7071C8.10536 31.5196 8 31.2652 8 31C8 30.7348 8.10536 30.4804 8.29289 30.2929C8.48043 30.1054 8.73478 30 9 30H15V25.95C12.5334 25.7021 10.2467 24.5468 8.58376 22.7083C6.92077 20.8698 5.99997 18.4791 6 16V14C6 13.7348 6.10536 13.4804 6.29289 13.2929C6.48043 13.1054 6.73478 13 7 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMic);
export default __webpack_public_path__ + "static/media/chatMic.b4c54f7342126d6a578f716397320869.svg";
export { ForwardRef as ReactComponent };